import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-fieldset',
  templateUrl: './fieldset.component.html',
  styleUrls: ['./fieldset.component.scss']
})
export class FieldsetComponent implements OnInit {

  @Input() legend;
  @Input() container: any[];
  @Input() classList: string[];

  constructor() {
  }

  public ngOnInit() {
    if (this.legend === 'Date de révocation') {
      console.log(this.container);
    }
  }

  public isContainerPresent(): boolean {
    const containerToString = String(this.container);
    if (containerToString && containerToString.length > 0) {
      // cas particulier
      return (containerToString + '') !== (String('\n\n') + '');
    }
    return false;
  }

  public toString(myString: any): string {
    if (this.legend === 'OID') {
      if (myString instanceof Array) {
        return myString.join('\n');
      }
    }
    if (myString instanceof Array) {
      return myString.join(' ');
    }
    return myString;
  }

}
